// extracted by mini-css-extract-plugin
export default {"container":"zz-z","dimension":"Az-z","dimensionLabels":"Bz-z"};